export default {"src":"/_next/static/media/Header Graphics.a409f8a8.svg","height":486,"width":1440,"blurWidth":0,"blurHeight":0};